import React from "react";
import { StarIcon } from "lucide-react";
import { testimonials } from "../data/testimonials";
function Stars() {
  return <div className="flex gap-0.5" role="img" aria-label="5 étoiles sur 5" data-id="element-210" data-mp="20q46ib0cvxbm">
      {Array.from({
      length: 5
    }, (_, i) => <StarIcon key={i} className="h-4 w-4 fill-brass text-brass" aria-hidden="true" data-id="element-211" data-mp="1mxy0hhqx36pw" />)}
    </div>;
}
export function TestimonialsSection() {
  const [featured, ...others] = testimonials;
  return <section className="bg-ebony py-20 md:py-28" aria-labelledby="testimonials-title" data-id="element-212" data-mp="1d47fwnxwvgfh">
      <div className="mx-auto max-w-6xl px-5" data-id="element-213" data-mp="1hyuthrrdmqfa">
        <div className="max-w-2xl" data-id="element-214" data-mp="141y5dy2n7n23">
          <h2 id="testimonials-title" className="font-display text-4xl uppercase leading-none text-linen md:text-6xl" data-id="element-215" data-mp="142r6ojiu1kcu">
            Ils enseignent déjà avec le pack
          </h2>
          <p className="mt-6 font-serif text-lg italic text-sand" data-id="element-216" data-mp="2yd34cp2sbbb3">
            Des professeurs de piano de toute la France partagent leur expérience.
          </p>
        </div>

        <div className="mt-14 grid gap-6 lg:grid-cols-[1.15fr_1fr]" data-id="element-217" data-mp="2uzzw2v9bakwb">
          <figure className="flex flex-col overflow-hidden rounded-2xl bg-linen" data-id="element-218" data-mp="2q39icekzc1e2">
            <img src={featured.image} alt={featured.name} className="aspect-[4/3] w-full object-cover object-top" data-id="element-219" data-mp="34r4b1uyzm5r5" />
            <div className="flex flex-1 flex-col p-8" data-id="element-220" data-mp="2zudtf37jb23m">
              <Stars data-id="element-221" data-mp="2c3rm5e5ctluo" />
              <blockquote className="mt-4 font-serif text-xl leading-relaxed text-ink md:text-2xl" data-id="element-222" data-mp="2c38dyp5iabtu">
                « {featured.quote} »
              </blockquote>
              <figcaption className="mt-auto pt-6" data-id="element-223" data-mp="2m162zev6wcni">
                <p className="font-semibold text-ink" data-id="element-224" data-mp="2lytfynakrc3l">{featured.name}</p>
                <p className="text-sm text-stone" data-id="element-225" data-mp="2h08c8dw46aae">{featured.role}</p>
              </figcaption>
            </div>
          </figure>

          <ul className="flex flex-col gap-6" data-id="element-226" data-mp="1ci49kqd03je">
            {others.map(t => <li key={t.name} className="flex-1" data-id="element-227" data-mp="3sgosg9fhsuyb">
                <figure className="flex h-full gap-5 rounded-2xl bg-walnut p-6" data-id="element-228" data-mp="3fk2o9hej6ws">
                  <img src={t.image} alt={t.name} className="h-24 w-24 shrink-0 rounded-xl object-cover object-top md:h-28 md:w-28" loading="lazy" data-id="element-229" data-mp="8dlmwxqkdc9u" />
                  <div className="flex flex-col" data-id="element-230" data-mp="ibj97fov4yzt">
                    <Stars data-id="element-231" data-mp="3gtx90ztg6ebh" />
                    <blockquote className="mt-3 leading-relaxed text-linen" data-id="element-232" data-mp="3guq433j1nfds">
                      « {t.quote} »
                    </blockquote>
                    <figcaption className="mt-auto pt-4" data-id="element-233" data-mp="3lqf93mdu1ohh">
                      <p className="font-semibold text-brass" data-id="element-234" data-mp="3qr2xe0aofr80">{t.name}</p>
                      <p className="text-sm text-sand/80" data-id="element-235" data-mp="3vj36ojcmzwh9">{t.role}</p>
                    </figcaption>
                  </div>
                </figure>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}